const debugbar = document.getElementById('ui-debug-bar');

if (debugbar) {
    debugbar.style.display = 'flex';
}
